import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'shared/Button';
import Message from 'shared/Message';
import Numpad from  './Numpad';
import styled from 'styled-components';

class PinEntry extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pin: "",
            pinError: false,
        };
    }


    changeValue = (numText) => {
        let pin = this.state.pin;
        if (numText === '<') {
            pin = pin.slice(0, -1);
        } else {
            pin += numText;
        }
        this.setState({ pin });
    }


    render() {
        return(
            <PinPad className="pinpad">
                {this.state.pinError &&
                    <PinPadMessage>
                        <Message error inlineText title="Incorrect PIN entered" />
                    </PinPadMessage>
                }
                <div className="input">
                    <NumInput className="input__control" type="password" value={this.state.pin} onChange={this.onPinChange} placeholder="Enter Pin Number"/>
                </div>
                <Numpad onKeyPress={this.changeValue} />
                <Button className="button button--block button--block--primary button--full" onClick={this.submitPin}>OK</Button>
            </PinPad>
        )
    }

    submitPin = () => {
        if(this.state.pin.length < 4) {
            return;
        }

        let req = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({listing: this.props.listingSlug, pin: this.state.pin})
        }

        return fetch(this.props.apiUrl + '/kiosks/pin-authenticate', req).then((res) => {
            if(res.status === 200) {
                return res.json();
            }
        }).then((res) => {
            if(res.authenticated === true) {
                this.setState({pinError: false});
                this.props.onAuthenticated(true);
            } else {
                this.setState({pinError: true});
            }
        }).catch((e) => {});
    }

    onPinChange = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let val = e.target.value;

        if(val.length > 6) {
            val = val.substr(0, 6);
        }

        this.setState({pin: val});
    }
}

PinEntry.propTypes = {
    apiUrl: PropTypes.string.isRequired,
    listingSlug: PropTypes.string.isRequired,
    onAuthenticated: PropTypes.func.isRequired,
}

PinEntry.defaultProps = {
}

export default PinEntry;


const PinPad = styled.div`
    width: 270px;
    margin: 0 auto;
    // padding: 0 30px;
`
const PinPadMessage = styled.div`
    margin-bottom: 20px;
    display: block;
`

const NumInput = styled.input`
    width: 100%;
    -moz-appearance:textfield;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &:focus, &:active{
        box-shadow: none;
        outline: none;
        border-color: blue;
    }
`
